import m from 'mithril';
import MessageProvider from '../../../MessageProvider';
import { RoomType } from '../../../Models';


interface Attrs {
    messageProvider: MessageProvider;
    roomType: RoomType;
    numberOfExtraBedsAllowed: number;    
}

export default function RoomTypeBookableOptionComponent(): m.Component<Attrs> {
    let showingDetails: boolean = false;  
    let selectedNumberOfExtraBeds = 0;

    return {
        view(vnode) {
            const {messageProvider, roomType, numberOfExtraBedsAllowed} = vnode.attrs;
            const maxOccupancy = roomType.standardOccupancy + selectedNumberOfExtraBeds;
            
            const bedType = roomType.beds.map((bed, index) => {
                let bedType = ""
                let bedUnitLabel = bed.quantity>1? " Beds" : " Bed";
                if(index < roomType.beds.length -1){
                    bedType += bed.quantity + " " + bed.type + bedUnitLabel + ", ";
                }else{
                    bedType += bed.quantity + " " + bed.type + bedUnitLabel;
                }
                return bedType;
            })

            return m("div", [
                m("div", { class: "p-3 border-top" }, [
                    m("div.d-flex", [
                        m("div.mr-auto", [
                            (roomType.beds.length > 0)?
                            m("div.text-muted", m("i.bi bi-usb-mini"), m("small.pl-2", bedType )):null,

                            (numberOfExtraBedsAllowed > 0)?
                            m("div.text-muted pl-4", m("small", messageProvider.get("can_add_extra_bed"))): null,

                            m("div.mt-2", 
                                m("small", {}, [
                                    m("div", { class: "text-muted" }, 
                                        m("i.bi bi-people pr-2"), messageProvider.interpolate("number_of_adults", {count:maxOccupancy})),
                                ])
                            ),
                            (roomType.maxChildAge > 0)? 
                            m("div.text-muted pl-4", m("small", messageProvider.interpolate("above_years_of_age", {years:roomType.maxChildAge}))):null,
                        ]),
                        m("div.text-right", [
                            [
                                m("div", { class: "total-rate" }, "MMK *****"),     
                                m("div", {}, [
                                    m("small.text-muted mt-0", {}, 
                                    "Choose dates and"
                                    )
                                ]),
                                m("div", {}, [
                                    m("small.text-muted mt-0", {}, 
                                    "Search to see the price."
                                    )
                                ]),
                            ],
                            
                        ])
                    ]),

                    (showingDetails) ?
                    m("div.mt-3", 
                        m("table", { class: "table table-sm table-striped table-border" }, [
                            m("tr", {}, [
                                m("th", {}, m("small.font-weight-bold", "Date")),
                                (selectedNumberOfExtraBeds > 0)?
                                m("th", m("small.font-weight-bold", "Extra")):null,

                                m("th", { class: "text-right" }, m("small.font-weight-bold", "Price"))
                            ])
                        ])
                    ): ""
                ]),
            ])
        }
    }
}